import { createFileRoute } from '@tanstack/react-router'
import { LoginForm } from '@/features/login-form'

export const Route = createFileRoute('/_login/login/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <LoginForm />
}
